import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/public/wechatNotify/sendRecord/select`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/public/wechatNotify/sendRecord/delete`,
    method: "POST",
    data,
    isEncrypt: false,
    isDecrypt: false,
  });
}
